import './App.css';
import HomePage from './HomePage/HomePage';

function App() {
  return (
    <HomePage/>
  );
}

export default App;
